import {
  type ConfigurationTemplateFunctionValue,
  isTemplateField,
  type TemplateField,
} from '../../types/templateModel'

export const documentationFromTemplateField = (
  field: TemplateField | ConfigurationTemplateFunctionValue,
) => (isTemplateField(field) ? field.value?.documentation : field.documentation)
